import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "../store/auth";
// AUD-U1d (21/10/2026) -- ponto unico de navegacao do usuario "checklist".
//
// Par do AUD-U1c: la a API recusa (403 em 43 rotas), aqui a tela deixa de
// oferecer. Este arquivo e CONVENIENCIA, nao protecao -- quem protege e o
// backend. Se alguem burlar isto no DevTools, a API continua recusando.
//
// Por que AQUI: o PrivateRoute envolve TODAS as rotas privadas, inclusive a
// "/" que renderiza o Dashboard (App.js). Um arquivo, 13 rotas, nenhuma
// pagina tocada. O Sidebar.js nao muda porque o checklist roda em tela
// cheia, sem menu -- o usuario desviado para la nunca ve o menu.
function papelDoToken() {
  // Mesma leitura do App.js e do Layout.js (atob no payload do JWT).
  // try/catch amplo de proposito: token ausente ou malformado nao tem o
  // direito de travar a navegacao de ninguem. Na duvida devolve "", que
  // significa "sem restricao" -- o lado seguro para um arquivo de tela.
  try {
    const token = (sessionStorage.getItem("access_token") || localStorage.getItem("access_token"));
    if (!token) return "";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return String(payload.papel || "").trim().toLowerCase();
  } catch { return ""; }
}
export default function PrivateRoute({ children }) {
  const { pathname } = useLocation();
  // A checagem de sessao vem PRIMEIRO e inalterada: quem nao esta logado
  // continua indo para o login, com papel ou sem papel.
  if (!isAuthenticated()) return <Navigate to="/login" />;
  // So o papel exatamente "checklist" e desviado, igual ao AUD-U1c.
  // startsWith cobre /checklist e /checklist/* de uma vez, e por isso o
  // desvio nao entra em laco: o destino casa com a propria condicao.
  if (papelDoToken() === "checklist" && !pathname.startsWith("/checklist")) {
    return <Navigate to="/checklist" replace />;
  }
  return children;
}